// Module
var code = "<div class=\"input-group\">\n  <input type=\"text\" class=\"form-control datepickerinput\" placeholder=\"Time\" />\n  <div class=\"input-group-addon\"><i class=\"fa fa-clock-o\"></i></div>\n</div>\n";
// Exports
module.exports = code;